<div class="speaker-profiles">
	@for (speaker of speakers || []; track $index;) {
		<div class="speaker-profile">
			<vb-profile-picture [profileUrl]="speaker.avatarImageUri" [size]="'xl'">
			</vb-profile-picture>
			<div class="speaker-text ms-3 lh-base">
				<header>{{speaker.name}}</header>
				@if(speaker.role) {
					<div>{{speaker.role}}</div>
				}
				{{speaker.description}}
			</div>
		</div>
	}
</div>
